<template>
  <div>
    <SearchBar
      text="Recherche"
      :dataSet="dataSet"
      :filter="filter"
      :filteringDelay="0"
      @filteringDone="handleFilteringDone"
    ></SearchBar>
    <ul>
      <li v-for="(item, index) in filteredData" :key="index">{{ item }}</li>
    </ul>
  </div>
</template>

<script>
import { SearchBar } from "@/components";
export default {
  name: "Boilerplate",
  components: {
    SearchBar
  },
  data() {
    return {
      dataSet: ["Maxime", "Samuel", "Philippe", "Gabriel"],
      filter: (s, data) => {
        console.log("Filtred");
        let result = [];
        data.forEach(element => {
          if (element.includes(s)) result.push(element);
        });
        return result;
      },
      filteredData: []
    };
  },
  methods: {
    handleFilteringDone(filteredData) {
      this.filteredData = filteredData;
      console.log("new data");
      console.log(this.filteredData);
    }
  },
  created() {
    this.filteredData = this.dataSet;
  }
};
</script>
